(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-2"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-all-reviews-classic"] && !Shopify.designMode) return;
  try {
      
     document.addEventListener("DOMContentLoaded", () => {
// Agrega un evento "click" a cada icono de reproducción
var playButtons = document.querySelectorAll('.play-button');
playButtons.forEach(function(playButton) {
  playButton.addEventListener('click', function() {
    var video = playButton.previousElementSibling;
    if (video.paused) {
      // Si el video está en pausa, lo reproduzco y oculto elicono de reproducción
      video.play();
      playButton.classList.add('playing');
      $(".owl-review").trigger('play.owl.autoplay', [2000]);
      console.log("video pausado, carusel en play");
    } else {
      // Si el video se está reproduciendo, lo pauso y muestro el icono de reproducción
      video.pause();
      playButton.classList.remove('playing');
       $(".owl-review").trigger('stop.owl.autoplay', [2000]);
      console.log("video play, carusel en pause");
    }
  });
});

// Agrega un evento "play" a cada elemento de video
var videos = document.querySelectorAll('.video');
videos.forEach(function(video) {
  video.addEventListener('play', function() {
    // Oculta el icono de reproducción cuando el video comienza a reproducirse
    var playButton = video.nextElementSibling;
    playButton.classList.add('playing');
     $(".owl-review").trigger('stop.owl.autoplay', [2000]);
    console.log("video en play, carusel en pausado");
  });
});

// Agrega un evento "pause" a cada elemento de video
videos.forEach(function(video) {
  video.addEventListener('pause', function() {
    // Muestra el icono de reproducción cuando el video se pausa
    var playButton = video.nextElementSibling;
    playButton.classList.remove('playing');
     $(".owl-review").trigger('play.owl.autoplay', [2000]);
    console.log("video pausado, carusel en play");
  });
});

  
})
         

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-all-reviews"] && !Shopify.designMode) return;
  try {
      
     document.addEventListener("DOMContentLoaded", () => {
// Agrega un evento "click" a cada icono de reproducción
var playButtons = document.querySelectorAll('.play-button');
playButtons.forEach(function(playButton) {
  playButton.addEventListener('click', function() {
    var video = playButton.previousElementSibling;
    if (video.paused) {
      // Si el video está en pausa, lo reproduzco y oculto elicono de reproducción
      video.play();
      playButton.classList.add('playing');
      $(".owl-review").trigger('play.owl.autoplay', [2000]);
      console.log("video pausado, carusel en play");
    } else {
      // Si el video se está reproduciendo, lo pauso y muestro el icono de reproducción
      video.pause();
      playButton.classList.remove('playing');
       $(".owl-review").trigger('stop.owl.autoplay', [2000]);
      console.log("video play, carusel en pause");
    }
  });
});

// Agrega un evento "play" a cada elemento de video
var videos = document.querySelectorAll('.video');
videos.forEach(function(video) {
  video.addEventListener('play', function() {
    // Oculta el icono de reproducción cuando el video comienza a reproducirse
    var playButton = video.nextElementSibling;
    playButton.classList.add('playing');
     $(".owl-review").trigger('stop.owl.autoplay', [2000]);
    console.log("video en play, carusel en pausado");
  });
});

// Agrega un evento "pause" a cada elemento de video
videos.forEach(function(video) {
  video.addEventListener('pause', function() {
    // Muestra el icono de reproducción cuando el video se pausa
    var playButton = video.nextElementSibling;
    playButton.classList.remove('playing');
     $(".owl-review").trigger('play.owl.autoplay', [2000]);
    console.log("video pausado, carusel en play");
  });
});

  
})
         

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-goals"] && !Shopify.designMode) return;
  try {
    


(function ($) {
  "use strict";



/*Efecto contador*/

  let contenedor = document.querySelector(".contenedor-mayor") ;
  let i = 0;
  function iniciar() {
    
  	let scrollTop = document.documentElement.scrollTop;
    let altura = contenedor.offsetTop;
    
    if(altura - 500 < scrollTop && i < 1) {
    
  $('.counter').each(function() {
  var $this = $(this),
    countTo = $this.attr('data-count').replace(/,/g, '');

  $({
    countNum: $this.text()
  }).animate({
    countNum: countTo
  }, {
    duration: 6000,
    easing: 'linear',
    step: function() {
      $this.text(numberWithCommas(Math.floor(this.countNum)));
    },
    complete: function() {
      $this.text(numberWithCommas(this.countNum));
    }
  });
});

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

     i = i + 1;

  }
  }
  window.addEventListener('scroll', iniciar);
}(jQuery));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-numbers"] && !Shopify.designMode) return;
  try {
    


       

(function ($) {
  
  "use strict";






/*Efecto contador*/

  let contenedor = document.querySelector(".contenedor-mayor") ;
  let i = 0;
  function iniciar() {
    
  	let scrollTop = document.documentElement.scrollTop;
    let altura = contenedor.offsetTop;
    
    if(altura - 500 < scrollTop && i < 1) {
    
  $('.counter').each(function() {
  var $this = $(this),
    countTo = $this.attr('data-count').replace(/,/g, '');

  $({
    countNum: $this.text()
  }).animate({
    countNum: countTo
  }, {
    duration: 6000,
    easing: 'linear',
    step: function() {
      $this.text(numberWithCommas(Math.floor(this.countNum)));
    },
    complete: function() {
      $this.text(numberWithCommas(this.countNum));
    }
  });
});

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

     i = i + 1;

  }
  }
  window.addEventListener('scroll', iniciar);
}(jQuery));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-reviews-classic"] && !Shopify.designMode) return;
  try {
    

  
     document.addEventListener("DOMContentLoaded", () => {
// Agrega un evento "click" a cada icono de reproducción
var playButtons = document.querySelectorAll('.play-button');
playButtons.forEach(function(playButton) {
  playButton.addEventListener('click', function() {
    var video = playButton.previousElementSibling;
    if (video.paused) {
      // Si el video está en pausa, lo reproduzco y oculto elicono de reproducción
      video.play();
      playButton.classList.add('playing');
      $(".owl-review").trigger('play.owl.autoplay', [2000]);
      console.log("video pausado, carusel en play");
    } else {
      // Si el video se está reproduciendo, lo pauso y muestro el icono de reproducción
      video.pause();
      playButton.classList.remove('playing');
       $(".owl-review").trigger('stop.owl.autoplay', [2000]);
      console.log("video play, carusel en pause");
    }
  });
});

// Agrega un evento "play" a cada elemento de video
var videos = document.querySelectorAll('.video');
videos.forEach(function(video) {
  video.addEventListener('play', function() {
    // Oculta el icono de reproducción cuando el video comienza a reproducirse
    var playButton = video.nextElementSibling;
    playButton.classList.add('playing');
     $(".owl-review").trigger('stop.owl.autoplay', [2000]);
    console.log("video en play, carusel en pausado");
  });
});

// Agrega un evento "pause" a cada elemento de video
videos.forEach(function(video) {
  video.addEventListener('pause', function() {
    // Muestra el icono de reproducción cuando el video se pausa
    var playButton = video.nextElementSibling;
    playButton.classList.remove('playing');
     $(".owl-review").trigger('play.owl.autoplay', [2000]);
    console.log("video pausado, carusel en play");
  });
});

  
})
         

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-reviews"] && !Shopify.designMode) return;
  try {
    
     document.addEventListener("DOMContentLoaded", () => {
    let reviewCarousel =  $(".owl-review");

       reviewCarousel.owlCarousel({
                center: false,
                loop: true,
                dots: false,
                nav: false,
                autoplay: true,
                /*autoplaySpeed: 300,*/
                autoplayHoverPause: true,
                /*smartSpeed: 500,*/
                margin: 20,
               
                   responsive:{
                    0:{
                        items:1,
                    },
                    600:{
                        items:2,
                    },
                    1000:{
                        items:2,
                  
                    }
                }
            })





})

  
     document.addEventListener("DOMContentLoaded", () => {
// Agrega un evento "click" a cada icono de reproducción
var playButtons = document.querySelectorAll('.play-button');
playButtons.forEach(function(playButton) {
  playButton.addEventListener('click', function() {
    var video = playButton.previousElementSibling;
    if (video.paused) {
      // Si el video está en pausa, lo reproduzco y oculto elicono de reproducción
      video.play();
      playButton.classList.add('playing');
      $(".owl-review").trigger('play.owl.autoplay', [2000]);
      console.log("video pausado, carusel en play");
    } else {
      // Si el video se está reproduciendo, lo pauso y muestro el icono de reproducción
      video.pause();
      playButton.classList.remove('playing');
       $(".owl-review").trigger('stop.owl.autoplay', [2000]);
      console.log("video play, carusel en pause");
    }
  });
});

// Agrega un evento "play" a cada elemento de video
var videos = document.querySelectorAll('.video');
videos.forEach(function(video) {
  video.addEventListener('play', function() {
    // Oculta el icono de reproducción cuando el video comienza a reproducirse
    var playButton = video.nextElementSibling;
    playButton.classList.add('playing');
     $(".owl-review").trigger('stop.owl.autoplay', [2000]);
    console.log("video en play, carusel en pausado");
  });
});

// Agrega un evento "pause" a cada elemento de video
videos.forEach(function(video) {
  video.addEventListener('pause', function() {
    // Muestra el icono de reproducción cuando el video se pausa
    var playButton = video.nextElementSibling;
    playButton.classList.remove('playing');
     $(".owl-review").trigger('play.owl.autoplay', [2000]);
    console.log("video pausado, carusel en play");
  });
});

  
})
         

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-sign-types-classic"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("load", function() {
    
    if (typeof jQuery !== 'undefined') {
        (function($) {
            
            let typesSing = $(".owl-types-sing");
            
            if (typesSing.length) {
                
                typesSing.owlCarousel({
                    center: false,
                    loop: true,
                    dots: false,
                    nav: false,
                    autoplay: true,
                    autoplaySpeed: 300,
                    autoplayHoverPause: true,
                    smartSpeed: 500,
                    margin: 20,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 2
                        },
                        1000: {
                            items: 2
                        }
                    }
                });

                $('.next-cat').on('click', function(e) {
                    e.preventDefault();
                    typesSing.trigger('next.owl.carousel');
                });

                $('.prev-cat').on('click', function(e) {
                    e.preventDefault();
                    typesSing.trigger('prev.owl.carousel');
                });
            }
            
        })(jQuery);
    }
});

  } catch(e) { console.error(e); }
})();
})();
